'use strict';
import moment from 'moment';
import * as T from 'prop-types';
import React from 'react';
import {Button} from '../../buttons/Button';
import {InputMoment} from '../InputMoment/index';
import {I18nComponent} from '../../../core-utilities/react-i18n';


export function BaseDateTimePickerView(props) {
  const moment = props.moment;
  return (
    <div className="DateTimePicker__backdrop">
      <div className="DateTimePicker">
        <div className="DateTimePicker__header">
          <div className="DateTimePicker__weekday">
            {moment.format('dddd')}
          </div>
          <div className="DateTimePicker__month">
            {moment.format('MMM')}
          </div>
          <div className="DateTimePicker__day">
            {moment.format('D')}
          </div>
          <div className="DateTimePicker__year">
            {moment.format('YYYY')}
          </div>
        </div>
        <InputMoment
          moment={moment}
          onChange={props.onUpdate}
          onSave={props.onChange}
          includeDate={props.includeDate}
          includeTime={props.includeTime}
        />
        <div className="DateTimePicker__buttonWrapper">
          <Button
            className="DateTimePicker__bottomButton"
            label={props.cancelLabel}
            onClick={props.onCancel}
          />
          <Button
            className="DateTimePicker__bottomButton"
            label={props.clearLabel}
            onClick={props.onClear}
          />
        </div>
      </div>
    </div>
  );
}

BaseDateTimePickerView.propTypes = {
  moment: T.instanceOf(moment),
  includeDate: T.bool.isRequired,
  includeTime: T.bool.isRequired,
  onCancel: T.func.isRequired,
  onChange: T.func.isRequired,
  onClear: T.func.isRequired,
  onUpdate: T.func.isRequired,

  cancelLabel: T.string,
  clearLabel: T.string,
};


export const DateTimePickerView = I18nComponent(BaseDateTimePickerView, [
  {code: 'default.cancel.label', prop: 'cancelLabel'},
  {code: 'default.clear.label', prop: 'clearLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/components/temporal/DateTimePicker/DateTimePickerView.js